import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';
import usePageTitle from '@/hooks/use-page-title';

const NotFound = () => {
    usePageTitle('Page non trouvée');

    return (
        <div className="flex flex-col items-center justify-center py-16 text-center" role="main" aria-labelledby="not-found-title">
            <p className="text-7xl font-bold text-primary" aria-hidden="true">404</p>
            <h1 id="not-found-title" className="text-2xl font-semibold mt-6">
                Page non trouvée
            </h1>
            <p className="text-muted-foreground mt-2 max-w-md">
                La page que vous recherchez n'existe pas ou a été déplacée.
            </p>
            <Button asChild className="mt-6 cursor-pointer">
                <Link to="/">
                    <Home className="w-4 h-4" aria-hidden="true" />
                    Retour à l'accueil
                </Link>
            </Button>
        </div>
    );
};

export default NotFound;
